import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { BackendDataShape, UsedAPI } from "api/config";
import CookieMonster from "api/CookieMonster";

export const letterTypeClassStoreAPI = createApi({
  reducerPath: "letterTypeClassStoreAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${UsedAPI}`,
    prepareHeaders: (headers) => {
      let token = CookieMonster.loadCookie("jwt");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["LetterTypeClassList"],
  endpoints: (builder) => {
    return {
      getLetterTypeClass: builder.query<string[], object>({
        query: () => {
          let type = "LETTER_TYPE_CLASS";
          let url = `/lov?type=${type}`;
          return {
            url,
            method: "GET",
          };
        },
        transformResponse: (response: BackendDataShape<string[]>) =>
          response.data,
        providesTags: ["LetterTypeClassList"],
      }),
    };
  },
});

export const {
  useGetLetterTypeClassQuery,
  util: { resetApiState: resetLetterTypeClassStoreAPI },
} = letterTypeClassStoreAPI;
